import * as React from "react";

import { Loader } from "@progress/kendo-react-indicators";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { getter } from "@progress/kendo-react-common";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import {
    Grid,
    GridColumn,
    GridFilterChangeEvent,
    GridSelectionChangeEvent,
    getSelectedState,
} from "@progress/kendo-react-grid";

import {
    filterBy,
    CompositeFilterDescriptor,
} from "@progress/kendo-data-query";

import EventNew from "./EventNew";
import EventView from "./EventView";

import { useGetFollowUpsQuery } from '../store/sunbright-api';
import { useDeleteFollowupMutation } from '../store/sunbright-api';
import { useAppSelector } from "../store/store";

const DATA_ITEM_KEY = "uid";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const initialFilter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
};

const EventsGrid = (props: any) => {
    const { data: followups, error: followupsError, isLoading: followupsLoading } = useGetFollowUpsQuery("");

    const [gridHeight, setGridHeight] = React.useState<string>("600px");

    const ActionCell = (props: any) => {
        const { dataItem } = props;

        return (
            <td className="k-command-cell">
                <Button
                    icon="trash"
                    style={{ background: "center" }}
                    onClick={(e) => deleteClicked(dataItem)}
                >
                </Button>
            </td>
        );
    };

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setGridHeight((window.innerHeight - 120) + "px");
   }, [followups]);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const auth = useAppSelector((state) => state.auth);
    const role = (auth && (auth.user !== undefined) && auth.user.role) ? auth.user.role : "";

    const [deleteEvent, deleteResponse] = useDeleteFollowupMutation();

    const [newFollowUp, setNewFollowUp] = React.useState<boolean>(false);
    const [filter, setFilter] = React.useState(initialFilter);
    const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
    const [eventToDelete, setEventToDelete] = React.useState<any>();

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const [selectedUID, setSelectedUID] = React.useState<string>("");

    const handleSelectionChange = (e: GridSelectionChangeEvent) => {
        const newState = getSelectedState({
            event: e,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        })
        setSelectedState(newState);

        setSelectedUID(Object.keys(newState)[0]);
    };

    const deleteClicked = (dataItem: any) => {
        setEventToDelete(dataItem);
        setConfirmDelete(true);
    };

    const deleteSelectedEvent = (dataItem: any) => {

        if (dataItem && dataItem.uid && dataItem.region) {
            const deleteItem: any = {
                uid: dataItem.uid,
                starttime: dataItem.startTime,
                host: dataItem.host,
                type: dataItem.type
            };

            deleteEvent(deleteItem)
                .unwrap()
                .then((payload) => { })
                .catch((error) => {
                    console.log(error)
                });
        }
        setConfirmDelete(false);
    };


    return (
        <React.Fragment>
            {(selectedUID.length !== 0) ?
                (< EventView
                    eventID={+selectedUID}
                    onReturn={() => setSelectedUID("")}
                />
                ) :
            (newFollowUp ?
                (<div>
                    <EventNew 
                        onReturn={(submitted: boolean) => setNewFollowUp(false)}
                    />
                </div>)
                :
                <div>
                    <div className="sds-gridHeader">Events</div>
                    {followupsError ? (<>Not Authorized</>) : followupsLoading ? <Loader size="large" type="converging-spinner" /> : followups ? (
                    <div>
                        <div>
                            {(confirmDelete) &&
                                <Dialog title={<div><span className="k-icon k-font-icon k-i-info" style={{ color: "green" }} ></span>&nbsp;Please confirm</div>}
                                    onClose={(e) => setConfirmDelete(false)}>
                                    <p style={{ margin: "25px", textAlign: "center" }}>
                                        Are you sure you want to delete <br />{eventToDelete?.startTime.toDateString().substring(4) + " " + eventToDelete?.type} ?
                                    </p>
                                    <DialogActionsBar>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            onClick={(e) => deleteSelectedEvent(eventToDelete)}
                                        >
                                            Yes
                                        </button>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            onClick={(e) => setConfirmDelete(false)}
                                        >
                                            No
                                        </button>
                                    </DialogActionsBar>
                                </Dialog>
                            }
                        </div>
                       <div style={{ position: "fixed", top: "46px", right: "64px", zIndex: "99"  }}>
                            <ButtonGroup>
                                <Button
                                    themeColor={"primary"}
                                    icon="plus-circle"
                                    style={{ borderLeftColor: "white", borderLeftWidth: "1px" }}
                                    onClick={() => setNewFollowUp(true)}>
                                    New Event
                                </Button>
                            </ButtonGroup>
                        </div>

                    <Grid
                        style={{ height: gridHeight }}
                        className="eventsGrid sds-selectable"
                        // data={followups}
                        data={filterBy(followups.map((item: any) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)]
                            })), filter)}
                        sortable={true}
                        filterable={true}
                        filter={filter}
                        onFilterChange={(e: GridFilterChangeEvent) => setFilter(e.filter)}
                        resizable={true}
                        reorderable={true}
                        size={"small"}
                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            mode: "single",
                        }}
                        onSelectionChange={handleSelectionChange}
                    >
                        <GridColumn field="startTime" title="Date" format="{0:MMM d yyyy}" filterable={false} />
                        <GridColumn field="type" title="Type" filterable={true} filter="text" />
                        <GridColumn field="host" title="Host/Location" filterable={true} filter="text" />
                        <GridColumn field="region" title="Region" filterable={true} filter="text" />
                        {(role.indexOf("Admin") !== -1) &&
                            <GridColumn cells={{ data: (props) => <ActionCell {...props} /> }} title=" " filterable={false} editable={false} width="50px" />}
                       </Grid>
                    </div>
                ) : null}
            </div >
            )}
        </React.Fragment>
    );
}
export default EventsGrid;
